import { Controller } from "@hotwired/stimulus";
import { initFeriasBulkApproval } from "../../modules/ferias/bulk_approval";
import { createFeriasApprovalsService } from "../../services/ferias_approvals_service";

export default class extends Controller {
  static values = {
    bulkUrl: String,
  };

  connect() {
    this.service = createFeriasApprovalsService({
      bulkUrl: this.bulkUrlValue,
    });

    this.bulk = initFeriasBulkApproval(this.element, this.service);
  }

  disconnect() {
    this.bulk?.destroy?.();
  }
}
